var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-lg-flex pl-lg-5"},[_c('div',{staticClass:"col-lg-5"},[_c('BOpenDataHeader',{staticClass:"mb-5"})],1),_c('div',{staticClass:"col-lg-7"},[_c('BOpenDataContent',{staticClass:"mb-4"}),_c('BOpenDataUpdated')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }